import { render, staticRenderFns } from "./ArtikelEdit.vue?vue&type=template&id=c59a21dc"
import script from "./ArtikelEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtikelEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports